import { useDispatch } from 'react-redux';
import { Navigate } from 'react-router';
import { signOut } from 'reducers/auth';

export default function SignOut() {
  const dispatch = useDispatch();
  dispatch(signOut());
  return <Navigate to="/" replace />;
}
